import { Store } from 'store/index';

const getCartHighLightedVouchers = (store: Store) => [1, 2, 3] as any[];

export default getCartHighLightedVouchers;
